var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('@truqc/content-path'),
  enumerateWildcardPath = _require.enumerateWildcardPath,
  mutateContentValue = _require.mutateContentValue,
  getContentValue = _require.getContentValue;
const filterObject = (object, wildcardPath, optionPath, optionIdentifier) => {
  const result = JSON.parse(JSON.stringify(object));
  enumerateWildcardPath(object, wildcardPath, (path, value) => {
    if (value !== undefined) {
      const option = getContentValue(optionPath, value) || {};
      const _Object$keys = Object.keys(option),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        testIdentifier = _Object$keys2[0];
      if (testIdentifier !== optionIdentifier) {
        mutateContentValue(path, result, null);
      }
    }
  });
  return result;
};
module.exports = {
  filterObject
};